import { render } from "./TreeList.vue?vue&type=template&id=1f672c46&scoped=true"
import script from "./TreeList.vue?vue&type=script&lang=js"
export * from "./TreeList.vue?vue&type=script&lang=js"

import "./TreeList.vue?vue&type=style&index=0&id=1f672c46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f672c46"]])

export default __exports__